import React, {
    useState,
    useRef,
    useEffect,
    Children
} from "react";

import "./Slider.css";


const Slider = ({
    children,
    autoPlay = true,
    interval = 4000
}) => {


    const slides = Children.toArray(children);

    const [index, setIndex] = useState(0);

    const timer = useRef(null);

    const touchStart = useRef(0);
    const touchEnd = useRef(0);



    const goNext = () => {

        setIndex(prev =>
            prev === slides.length - 1
                ? 0
                : prev + 1
        );

    };



    const goPrev = () => {

        setIndex(prev =>
            prev === 0
                ? slides.length - 1
                : prev - 1
        );

    };



    const startAutoPlay = () => {

        clearInterval(timer.current);


        if(autoPlay && slides.length > 1){

            timer.current = setInterval(
                goNext,
                interval
            );

        }

    };



    useEffect(()=>{

        startAutoPlay();


        return ()=>{

            clearInterval(timer.current);

        };


    },[index, interval, autoPlay, slides.length]);





    const handleNext = ()=>{

        goNext();

        startAutoPlay();

    };



    const handlePrev = ()=>{

        goPrev();

        startAutoPlay();

    };



    const handleDotClick=(i)=>{

        setIndex(i);

        startAutoPlay();

    };





    const handleTouchStart=(e)=>{

        touchStart.current =
        e.changedTouches[0].clientX;

    };



    const handleTouchEnd=(e)=>{

        touchEnd.current =
        e.changedTouches[0].clientX;


        const distance =
        touchStart.current -
        touchEnd.current;


        if(distance > 60){

            handleNext();

        }


        if(distance < -60){

            handlePrev();

        }

    };




    return (

        <div

            className="slider-container"

            onTouchStart={handleTouchStart}

            onTouchEnd={handleTouchEnd}

        >


            <div

                className="slider-track"

                style={{
                    transform:
                    `translateX(-${index * 100}%)`
                }}

            >


            {
                slides.map((slide,i)=>(

                    <div

                        className="slide"

                        key={i}

                    >

                        {slide}

                    </div>

                ))
            }


            </div>





            {
                slides.length > 1 &&

                <>


                <button

                    type="button"

                    className="slider-arrow left"

                    onClick={handlePrev}

                    aria-label="Previous slide"

                >

                    ‹

                </button>



                <button

                    type="button"

                    className="slider-arrow right"

                    onClick={handleNext}

                    aria-label="Next slide"

                >

                    ›

                </button>




                <div className="slider-dots">


                {
                    slides.map((_,i)=>(

                        <button

                            type="button"

                            key={i}

                            aria-label={`Go to slide ${i+1}`}

                            className={
                                index === i
                                ?
                                "dot active"
                                :
                                "dot"
                            }


                            onClick={()=>
                                handleDotClick(i)
                            }

                        />

                    ))
                }


                </div>


                </>

            }


        </div>

    );

};


export default Slider;